module.exports = require('./handlebars')